import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import userListTable from '@/components/user/userListTable.vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { UserActions } from '@/store/modules/user';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "UserList",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

onMounted(async () => {
    await store.dispatch(`user/${UserActions.asyncGetUserList}`);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(userListTable))
}
}

})